import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
    form: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 'calc(100% - 60px)'
    },
    itemList: {
        overflowX: 'hidden',
        height: '100%',
        marginTop: 10
    },
    topDivider: {
        marginLeft: -25,
        marginRight: -25,
        paddingBottom: '0 !important'
    }
}));
